export enum EGroupBy {
  STATUS = "STATUS",
  DEVICE_TYPE = "DEVICE_TYPE",
  DEVICE_CATEGORY = "DEVICE_CATEGORY",
}
